import { render, staticRenderFns } from "./MainDeposit.vue?vue&type=template&id=3ce3ab5a&scoped=true&"
import script from "./MainDeposit.vue?vue&type=script&lang=ts&"
export * from "./MainDeposit.vue?vue&type=script&lang=ts&"
import style0 from "./MainDeposit.vue?vue&type=style&index=0&id=3ce3ab5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce3ab5a",
  null
  
)

export default component.exports